import React, { Component } from 'react';
import { Settings as SettingsIcon } from "@material-ui/icons";
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Card, CardContent, WithStyles } from '@material-ui/core';
import MainCard from "./MainCard";
import DashboardUserlist from './DashboardUserlist';
import DashboardStats from './DashboardStats';
import MyCourses from './MyCourses';
import MyReviewee from './MyReviewee';
import MentionsYou from './MentionsYou';
import MyPATIconButton from "../../common/MyPATIconButton";
import RecentComments from './RecentComments';
import { dashboardService } from '../services/dashboardService'
// @ts-ignore
const styles = theme => ({
  root: {
    margin: theme.spacing.unit
  },
  mt1x: {
    marginTop: theme.spacing.unit * 2,
  },
  gridFlex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  anchor: {
    textDecoration: "none",
  },
  setting: {
    height: theme.spacing.unit * 4,
    width: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit,
    background: '#fff',
    borderRadius: "50%",
  },
  sIcon: {
    color: '#BABABA',
  },

});

interface DashboardProps extends WithStyles<typeof styles> {
  
}

interface DashboardStates{
  mentionsYouComments:any[],
  recentComments: any[],
  myCourses: any[],
}

class Dashboard extends Component< DashboardStates> {
  
    state = {
      mentionsYouComments:[],
      recentComments:[],
      myCourses:[],
    }
  

  componentDidMount(){
    dashboardService.getMentionOfYou()
    .then((res:any) =>{
      let mentions = res.map((mention:any) =>{
        return {
          name: mention.userId.fullName,
          imgSrc: mention.userId.profileImage,
          comment: mention.comment,
          activity: mention.updatedAt,
        }
      })
      this.setState({mentionsYouComments:mentions})
    });

    dashboardService.getRecentComments()
    .then((res:any) =>{
      let comments = res.map((comment:any) =>{
        return {
          name: comment.userId.fullName,
          imgSrc: comment.userId.profileImage,
          comment: comment.comment,
          activity: comment.updatedAt,
        }
      })
      this.setState({recentComments:comments})
    });

    dashboardService.getMyCourses()
    .then((res:any) =>{
      let myCourses = res.map((course:any) =>{
        let goals = course.goals.map((goal:any)=>(goal.name)).join(' ');
        return {
          name: course.name,
          goals:goals,
          activity: course.updatedAt,
        }
      })
      this.setState({myCourses})
    });
  }

  render() {
    // @ts-ignore
    const { classes } = this.props;
    const { mentionsYouComments ,recentComments ,myCourses } = this.state;

    return (
      <>
        <Grid container className={classes.root}>
          <Grid item sm={12} className={classes.gridFlex}>
            <Typography variant="h5"  gutterBottom inline>Dashboard</Typography>
            <a className={classes.anchor}>
              <MyPATIconButton buttonVariant="flat">
                <SettingsIcon className={classes.sIcon}></SettingsIcon>
              </MyPATIconButton>
            </a>
          </Grid>
        </Grid>

        {/* header ends */}

        {/* main contents */}
        <Grid container>
          <Grid item sm={8}>
            <DashboardStats />
            <Grid container spacing={16}>
              <Grid item xs={6}>
                <MyCourses myCourses={myCourses} />
              </Grid>
              <Grid item xs={6}>
                <MyReviewee />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={4}>
            <DashboardUserlist />
          </Grid>
        </Grid>

        <Grid container >
          <Grid item sm={8} >
            <Grid container spacing={16}>
              <Grid item sm>
                <MentionsYou
                  mentionsYouComments={mentionsYouComments}
                />
              </Grid>

              <Grid item sm >
                <RecentComments
                  recentComments={recentComments}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
};

export default withStyles(styles)(Dashboard);
